import { useEffect, useState } from 'react'

export default function useDisplayUnits(displayUnitStore) {
    const [displayUnitData, setDisplayUnitData] = useState(displayUnitStore ? displayUnitStore.getState() : null)

    useEffect(() => {
        if (displayUnitStore) {
            // returns unsub function
            return displayUnitStore.subscribe(() => {
                setDisplayUnitData(displayUnitStore.getState())
            })
        }
    }, [displayUnitStore])

    return displayUnitData || {}
}
